import VisualizarTypes from './types'

const INITIAL_STATE = {
    dados: [],
    id: 0,
    error: false,
    loading: true
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VisualizarTypes.VIEW_REQUEST:
            return { ...state, id: action.payload.id, loading: true }

        case VisualizarTypes.CLEAR:
            return INITIAL_STATE;
        case VisualizarTypes.VIEW_PROTOCOLO:
            return {
                ...state,
                dados: action.payload,
                loading: false, error: false
            }

        default:
            return state;
    }
}